import classNames from "classnames";
import Badge from "../../ui/Badge/Badge";
import Background from "./Background.svg?react";
import styles from "./ErrorPage.module.scss";

function ErrorPage({
  errorCode,
  title,
  subtitle,
  children,
  className,
}: {
  errorCode: string;
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.badgeContainer}>
        <Background className={styles.background} />
        <Badge variant="badge" color="primary" className={styles.badge}>
          {errorCode}
        </Badge>
      </div>

      <h1 className={styles.title}>{title}</h1>
      <p className={styles.subtitle}>{subtitle}</p>
      {children}
    </div>
  );
}

export default ErrorPage;
